/** Fecha YYYY-MM-DD para inputs date. */
export function toDateInput(value: string | Date | null | undefined): string | null {
  if (!value) return null;
  const s = value instanceof Date
    ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
    : String(value);
  const day = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(day)) return day;
  return null;
}

/** Hoy + N días en formato input date. */
export function datePlusDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return toDateInput(d) as string;
}
